import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, Observable, of, switchMap, take, tap, throwError } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { environment } from "src/environments/environment";
import { PaginationRequest } from "src/app/models/common.request";
import { IDrug, IDrugDetail } from "./idrug";
import { CommonDropDown } from "src/app/common/types/dropdown.type";


@Injectable({ providedIn: 'root' })
export class DrugService {

    private _drug: BehaviorSubject<IDrug | null> = new BehaviorSubject<IDrug | null>(null);
    private _drugs: BehaviorSubject<IDrug[]> = new BehaviorSubject<IDrug[]>([]);
    private _pagination: BehaviorSubject<PaginationResult | null> = new BehaviorSubject<PaginationResult | null>(null);

    constructor(
        private _httpClient: HttpClient
    ) { }

    get drug$(): Observable<IDrug | null> {
        return this._drug.asObservable();
    }

    get drugs$(): Observable<IDrug[]> {
        return this._drugs.asObservable();
    }

    get pagination$(): Observable<PaginationResult | null> {
        return this._pagination.asObservable();
    }

    getAllDrugs(drug: PaginationRequest): Observable<BaseRespone<{ pagination: PaginationResult; drugDetails: IDrug[] }>> {
        return this._httpClient.post<BaseRespone<{ pagination: PaginationResult; drugDetails: IDrug[] }>>(`${environment.baseURl}/Drug/list`, drug).pipe(
            tap((response) => {
                this._pagination.next(response.result.pagination);
                this._drugs.next(response.result.drugDetails);
            }),
            catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    createDrugs(drugdetails: IDrug): Observable<BaseRespone<IDrug>> {
        return this._httpClient.post<BaseRespone<IDrug>>(`${environment.baseURl}/Drug`, drugdetails)
            .pipe(
                catchError((error) => {
                    return of(error.error);
                }),
                map((newtype) => {
                    // Return the new
                    return newtype;
                })
            )
    }

    deleteDrug(id: number): Observable<BaseRespone<boolean>> {
        return this.drugs$.pipe(
            take(1),
            switchMap(drug =>
                this._httpClient.delete<BaseRespone<boolean>>(`${environment.baseURl}/Drug/${id}`).pipe(
                    map((deletedResponse) => {
                        if (deletedResponse.result) {

                            const updated = drug.filter(item => item.id !== id);
                            this._drugs.next(updated);
                        }
                        return deletedResponse;
                    })
                )
            ), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    updateDrug(drugdetails: IDrug): Observable<BaseRespone<IDrug>> {
        return this.drugs$.pipe(
            take(1),
            switchMap(drugs => this._httpClient.put<BaseRespone<IDrug>>(`${environment.baseURl}/Drug`, drugdetails).pipe(
                map((updated: BaseRespone<IDrug>) => {

                    // Find the index of the updated product
                    const index = drugs.findIndex(item => item.id === drugdetails.id);

                    // Update the product
                    drugs[index] = drugdetails;

                    // Update the products
                    this._drugs.next(drugs);

                    // Return the updated product
                    return updated;
                })
            )), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    getDrugDetails(): Observable<BaseRespone<IDrugDetail[]>> {
        return this._httpClient.get<BaseRespone<IDrugDetail[]>>(`${environment.baseURl}/Drug/lookup`).pipe(
            tap((response) => {
                return response;
            }),
            catchError((error) => {
                console.error('Error to Fetching data:', error);
                return throwError(() => error);
            })
        );
    }
}